import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { AuthRoute } from '../components/AuthRoute';
import { LoginPage } from './LoginPage';
import { HomePage } from './HomePage';
//import { SignupPage } from './SignupPage';
import { TopNavBar } from '../components/TopNavBar';
import { ProductListPage } from './ProductListPage';
import { Footer } from '../components/Footer';
import { NonMemberPage } from './NonMemberPage';
import { SearchResultsPage } from './SearchResultsPage';
import { SignupSuccessPage } from './SignupSuccessPage';
import { BottomNavBar } from '../components/BottomNavBar';
import { ProductPage } from './ProductPage';
import { CartPage } from './CartPage';
import { CartPaymentPage } from './CartPaymentPage';
import { CartPaymentSuccessPage } from './CartPaymentSuccessPage';
import { LookbookPage } from './LookbookPage';
import { LookbookWomenPage } from './LookbookWomenPage';
import { LookbookMenPage } from './LookbookMenPage';
import { BrandPage } from './BrandPage';
import { HistoryPage } from './HistoryPage';
import { Certification } from './certification';
import { Personalpolicy } from './personalpolicy';
import { Inspection } from './inspection';
import { Terms } from './terms';
import { CorporateResponsibilityPage } from './CorporateResponsibilityPage';
import { MyPage } from './MyPage/MyPage';
import { CustomerCarePage } from './CustomerCare/CustomerCarePage';
import { WorkWithUsPage } from './WorkWithUsPage';
import { WorkWithUsDetailPage } from './WorkWithUsDetailPage';
import { JournalPage } from './JournalPage';
import { JournalDetailPage } from './JournalDetailPage';
import { MyLikedPage } from './MyLikedPage';
import { OutletsPage } from './Outlet/OutletsPage';
import { MobileCategoryPage } from './MobileCategoryPage';
import CartPaymentProcessing from './CartPaymentProcessing';
import CartRequestSuccessPage from './CartRequestSuccessPage';
import NonMemberOrderDetail from './NonMemberOrderDetail';
import CartPaymentProcessingRe from './CartPaymentProcessingRe';
import { MyPageOrdersCancel } from './MyPage/MyPageOrdersCancel';
import UserCheck from './UserCheck';
import FindId from './Find/FindId';
import Password from './Find/password';
import { MyPageOrdersExchange } from './MyPage/MyPageOrdersExchange';
import { MyPageOrdersEditSize } from './MyPage/MyPageOrdersEditSize';
import { MyPageOrdersRefund } from './MyPage/MyPageOrdersRefund';
import { ApgujeongDetail } from './Outlet/OutletDetailPage/ApgujeongDetail';
import { CentumDetail } from './Outlet/OutletDetailPage/CentumDetail';
import { CheonanDetail } from './Outlet/OutletDetailPage/CheonanDetail';
import { LotteDetail } from './Outlet/OutletDetailPage/LotteDetail';
import { CoexDetail } from './Outlet/OutletDetailPage/CoexDetail';
import { DaeguDetail } from './Outlet/OutletDetailPage/DaeguDetail';
import { DongseongroDetail } from './Outlet/OutletDetailPage/DongseongroDetail';
import { GwangjuDetail } from './Outlet/OutletDetailPage/GwangjuDetail';
import { HongdaeDetail } from './Outlet/OutletDetailPage/HongdaeDetail';
import { JejuDetail } from './Outlet/OutletDetailPage/JejuDetail';
import { JeonjuDetail } from './Outlet/OutletDetailPage/JeonjuDetail';
import { TimeDetail } from './Outlet/OutletDetailPage/TimeDetail';
import { RefundDetail } from './MyPage/RefundDetail';
import { historyState } from '../plugins/ridge';
import { useHistory } from 'react-router-dom';
import { some, startsWith } from 'lodash';
import { getUserInfo } from '../apis/user';
import Verified from "./verification";
import PersonalVerificationPage from "./PersonalVerification/PersonalVerificationPage";

const CHECK_USER_PATHS = ['/mypage', '/my'];
const CHECK_TEST_USER_ID = [2792331, 2792348, 2792590, 2806593, 3177568, 2806649, 2792349, 2806638, 27189, 2792328, 1642129, 31572, 21427, 29611, 2792326, 10438, 93647, 752458, 326527, 2060028, 10227, 3177587, 2989826];

export const Router = () => {
  const history = useHistory();
  const testUserCheck = (pathname: string) => {
    if (process.env.REACT_APP_MODE === 'development') return;
    getUserInfo()
        .then(
            r => {
               if(!CHECK_TEST_USER_ID.includes(r.data.payload.userId)) {
                pathname.indexOf('/inspection') === -1 && history.replace('/inspection');
              }
            }
        )
        .catch((e) =>{
              pathname.indexOf('/inspection') === -1 && history.replace('/inspection');
            }
        );
  }
  const _checkUser = (pathname: string) => {
    if (some(CHECK_USER_PATHS, path => startsWith(pathname, path))) {
      getUserInfo().catch((e) =>
          e.response.status === 403 &&
            history.replace(`/login?location=${pathname}`)
      )
    }
  };

  useEffect(() => {
    historyState.set(history);
    //testUserCheck(history.location.pathname);
    _checkUser(history.location.pathname);
    history.listen((location, action) => {
      //testUserCheck(location.pathname);
      _checkUser(location.pathname);
    });
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <TopNavBar />
      <main className="flex-1 relative px-4 py-0">
        <Switch>
          <Route path="/journal/:id" component={JournalDetailPage} />
          <Route path="/journal" component={JournalPage} />
          <Route path="/apgujeongdetail" component={ApgujeongDetail} />
          <Route path="/centumdetail" component={CentumDetail} />
          <Route path="/cheonandetail" component={CheonanDetail} />
          <Route path="/lottedetail" component={LotteDetail} />
          <Route path="/coexdetail" component={CoexDetail} />
          <Route path="/daegudetail" component={DaeguDetail} />
          <Route path="/dongseongrodetail" component={DongseongroDetail} />
          <Route path="/gwangjudetail" component={GwangjuDetail} />
          <Route path="/hongdaedetail" component={HongdaeDetail} />
          <Route path="/jejudetail" component={JejuDetail} />
          <Route path="/jeonjudetail" component={JeonjuDetail} />
          <Route path="/timedetail" component={TimeDetail} />
          <Route path="/work-with-us/:id" component={WorkWithUsDetailPage} />
          <Route path="/work-with-us" component={WorkWithUsPage} />
          <Route path="/cc" component={CustomerCarePage} />
          <Route path="/verification" component={Verified} />
          <Route
            path="/corporate-responsibility"
            component={CorporateResponsibilityPage}
          />
          <Route path="/history" component={HistoryPage} />
          <Route path="/certification" component={Certification} />
          <Route path="/personalpolicy" component={Personalpolicy} />
          <Route path="/inspection" component={Inspection} />
          <Route path="/terms" component={Terms} />
          <Route path="/one-brand" component={BrandPage} />
          <Route path="/store" component={OutletsPage} />
          <Route path="/lookbook/2023fw-men" component={LookbookMenPage} />
          <Route path="/lookbook/2023fw-women" component={LookbookWomenPage} />
          <Route path="/lookbook" component={LookbookPage} />
          <Route path="/results/:keyword" component={SearchResultsPage} />

          <Route
            path="/non-member/:orderNumber/edit-size"
            component={MyPageOrdersEditSize}
          />
          <Route
            path="/non-member/:orderNumber/exchange"
            component={MyPageOrdersExchange}
          />
          <Route
            path="/non-member/:orderNumber/refund"
            component={MyPageOrdersRefund}
          />
          <Route
            path="/non-member/:orderNumber/cancel"
            component={MyPageOrdersCancel}
          />
          <Route
            path="/non-member/refunds/:orderNumber"
            component={RefundDetail}
          />
          <Route
            path="/non-member/:orderNumber"
            component={NonMemberOrderDetail}
          />
          <AuthRoute path="/non-member" component={NonMemberPage} guestOnly />

          <Route path={'/check/:to'} component={UserCheck} />

          <Route
            path="/cart/payment/success/:mobile"
            component={CartPaymentSuccessPage}
          />
          <Route
            path="/cart/payment/success"
            component={CartPaymentSuccessPage}
          />
          <Route
            path="/cart/request/success/:mobile"
            component={CartRequestSuccessPage}
          />
          <Route
            path="/cart/request/success"
            component={CartRequestSuccessPage}
          />
          <Route
            path="/cart/payment/processing"
            component={CartPaymentProcessing}
          />
          <Route
            path="/cart/request/processing"
            component={CartPaymentProcessingRe}
          />
          <Route path="/cart/payment" component={CartPaymentPage} />
          <Route path="/cart" component={CartPage} />
          <Route
            path="/p/:categoryName/:categoryIdString/:subCategoryIdString"
            component={ProductListPage}
          />
          <Route
            path="/p/:categoryName/:categoryIdString"
            component={ProductListPage}
          />
          <Route path="/product/:id" component={ProductPage} />
          <AuthRoute
            path="/signup/success"
            component={SignupSuccessPage}
            guestOnly
          />
          <AuthRoute path="/personal-verification" component={PersonalVerificationPage} guestOnly />
          <AuthRoute path="/login" component={LoginPage} guestOnly />
          <AuthRoute path="/find/id" component={FindId} guestOnly />
          <AuthRoute path="/find/password" component={Password} guestOnly />
          <Route path="/my/liked" component={MyLikedPage} />
          <Route path="/mypage" component={MyPage} />
          <Route path="/m/category" component={MobileCategoryPage} />
          <Route path="/" component={HomePage} exact />
          <Route path="/">
            <Redirect to="/" />
          </Route>
        </Switch>
      </main>
      <Switch>
        <Route
          path={[
            '/signup',
            '/personal-verification',
            '/login',
            '/non-member',
            '/app-download',
            '/find/id',
            '/find/password',
          ]}
        />
        <Route path={'/'} component={Footer} />
      </Switch>

      <BottomNavBar />
      <div className="md:hidden" style={{ height: 80 }} />
    </div>
  );
};
